import { Download } from 'lucide-react';
import { usePWAInstall } from '../hooks/usePWAInstall';

export default function InstallPwaButton() {
  const { canInstall, install } = usePWAInstall();
  if (!canInstall) return null;
  return (
    <button
      onClick={install}
      className="btn-secondary hidden sm:inline-flex !px-3 !py-1.5 text-xs"
      title="Instalar como aplicativo"
    >
      <Download className="h-4 w-4" />
      Instalar
    </button>
  );
}
